export default "__VITE_ASSET__908523f9__"